import { getDropDownProps } from "./dropDown/getDropDownProps";

export const getDefaultProps = ({ searchMode, searchParams, placeholderOverride }) => {
    const dropDown = getDropDownProps({ searchType: searchMode, placeholderOverride });

    const { isSearchPage, searchTerm } = searchParams;

    return {
        dropDown,
        inputValue: isSearchPage ? searchTerm : "",
    };
};
